var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentMapSlidingDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41924",
    "data-name": "Group 41924",
    transform: "translate(17366 -2462)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15796",
    "data-name": "Rectangle 15796",
    width: 32,
    height: 32,
    transform: "translate(-17366 2462)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41922",
    "data-name": "Group 41922",
    transform: "translate(-103 -98)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M100.652-484.214h-8v-2h8v2",
    transform: "translate(-17355.652 3061.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64-2",
    "data-name": "path64",
    d: "M100.652-484.214h-8v-2h8v2",
    transform: "translate(-17331.652 3061.215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    d: "M453.518-681.808h-.5v-8h.5v8",
    transform: "translate(-17936.809 2122.483) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28-2",
    "data-name": "path28",
    d: "M453.518-681.808h-.5v-8h.5v8",
    transform: "translate(-17928.809 2122.983) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentMapSlidingDoor);
export default __webpack_public_path__ + "static/media/agent-map-sliding-door.c7d5cec132abf9419c973650c689230d.svg";
export { ForwardRef as ReactComponent };